import React from 'react';

export default function Input({ label, helper, error, ...props }) {
  return (
    <label className={`input-field ${error ? 'input-error' : ''}`}>
      <span className="input-label">{label}</span>
      <input className="input" {...props} />
      {helper ? <span className="input-helper">{helper}</span> : null}
      {error ? <span className="input-error-text">{error}</span> : null}
    </label>
  );
}
